import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import AppHero from './AppHero.tsx'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import './index.css'
import { ENV } from './constants/env.ts'

const queryClient = new QueryClient()

export default function mount() {
  createRoot(document.getElementById('hero-root')!).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <AppHero />
      </QueryClientProvider>
    </StrictMode>
  )
}

mount()
const w = (window as any) || {}
w.ListingDrWidgetHero = {
  default: mount,
  version: import.meta.env.VITE_CI_JOB_ID ?? 'dev',
}
if (console && console.log) {
  console.log('Listing Doctor ' + w.ListingDrWidgetHero.version, ENV)
}
